import {Component, Inject} from '@angular/core';
import {MdDialog, MdDialogRef, MD_DIALOG_DATA} from '@angular/material';
/**
 * \@title Dialog Overview
 */
export class DialogOverviewExample {

  animal: string;
  name: string;
/**
 * @param {?} dialog
 */
constructor(public dialog: MdDialog) {}
/**
 * @return {?}
 */
openDialog(): void {
    let /** @type {?} */ dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      width: '250px',
      data: { name: this.name, animal: this.animal }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.animal = result;
    });
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'dialog-overview-example',
  templateUrl: 'dialog-overview-example.html'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdDialog, },
];
}

function DialogOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
DialogOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DialogOverviewExample.ctorParameters;
/** @type {?} */
DialogOverviewExample.prototype.animal;
/** @type {?} */
DialogOverviewExample.prototype.name;
/** @type {?} */
DialogOverviewExample.prototype.dialog;
}

export class DialogOverviewExampleDialog {
/**
 * @param {?} dialogRef
 * @param {?} data
 */
constructor(
public dialogRef: MdDialogRef<DialogOverviewExampleDialog>,
public data: any) { }
/**
 * @return {?}
 */
onNoClick(): void {
    this.dialogRef.close();
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'dialog-overview-example-dialog',
  templateUrl: 'dialog-overview-example-dialog.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdDialogRef, },
{type: undefined, decorators: [{ type: Inject, args: [MD_DIALOG_DATA, ] }, ]},
];
}

function DialogOverviewExampleDialog_tsickle_Closure_declarations() {
/** @type {?} */
DialogOverviewExampleDialog.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DialogOverviewExampleDialog.ctorParameters;
/** @type {?} */
DialogOverviewExampleDialog.prototype.dialogRef;
/** @type {?} */
DialogOverviewExampleDialog.prototype.data;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
